<mat-card appearance="outlined">
    <mat-card-content [formGroup]="formGroup" fxLayout="column" fxLayoutAlign="space-between stretch">
        <div fxLayoutAlign="space-between center">
            <div fxFlex>
                {{fullMailingAddress}}
            </div>

            <lgd-checkbox controlName="isPrimary" label="Primary" aria-label="Check-Primary-MailingAddress-Contact">
            </lgd-checkbox>

            <lgd-checkbox controlName="isForwarding" label="Forwarding" aria-label="Check-Forwarding-MailingAddress-Contact">
            </lgd-checkbox>

            <lgd-checkbox *ngIf="showCertify" controlName="isCertified" label="Certified" aria-label="Check-Certified-MailingAddress-Contact">
            </lgd-checkbox>

            <button *ngIf="!viewOnly" mat-icon-button (click)="deleteClicked()" matTooltip="Delete" telemetry="Submission-Delete">
                <mat-icon>delete</mat-icon>
            </button>

            <button *ngIf="!viewOnly" mat-icon-button (click)="editClicked()" matTooltip="Edit" telemetry="Submission-Edit">
                <mat-icon>edit</mat-icon>
            </button>
        </div>

        <div *ngIf="showUsages" fxFlex="100" fxLayout="column" fxLayoutAlign="end end" class="error">
            <div>This Address cannot be deleted because it is in use on an Account</div>
            <div>Account: {{usages}}</div>
        </div>

        <div *ngIf="showCertification">
            <b>Certification Results:</b> {{certificationResults}}
        </div>

        <div *ngIf="isEditAddress" fxLayoutAlign="space-between start">
            <lgd-text fxFlex="12" controlName="attention" label="Attention" telemetry="Edit-Attention">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="line1" label="Line 1" telemetry="Edit-Line1">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="line2" label="Line 2" telemetry="Edit-Line2">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="city" label="City" telemetry="Edit-City">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="state" label="State" telemetry="Edit-State">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="postalCode" label="Zip" telemetry="Edit-Zip">
            </lgd-text>

            <lgd-text fxFlex="12" controlName="country" label="Country" telemetry="Edit-Country">
            </lgd-text>

            <button *ngIf="showCertify" mat-icon-button (click)="certifyClicked()" [matTooltip]="getCertifyTooltip()" telemetry="Submission-CertifyButton">
                <mat-icon>card_membership</mat-icon>
            </button>
        </div>
    </mat-card-content>
</mat-card>